import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import CoverLayout from "layouts/CoverLayout";
import curved9 from "assets/images/curved-images/curved-6.jpg";
import Loader from "components/loader";

function SignIn() {
  const [emailText, setEmail] = useState();
  const [passwordText, setPassword] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSetEmail = (emailText) => setEmail(emailText.target.value);
  const handleSetPassword = (passwordText) => setPassword(passwordText.target.value);
  const handleSignIn = () => {
    setIsLoading(true);
    fetch(process.env.REACT_APP_API_URL + 'login', {
      method: 'POST',
      body: JSON.stringify({
        email: emailText,
        password: passwordText,
      }),
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json"
      }
    })
      .then(response => response.json())
      .then((responseData) => {
        if (responseData.statusCode === 200) {
          localStorage.setItem('isLoggedIn', true);
          localStorage.setItem('userData', JSON.stringify(responseData['data']));
          setIsLoading(false);
          navigate('/dashboard', { replace: true });
        }

        throw new Error(responseData);
      })
      .catch(function (error) {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (localStorage.getItem('isLoggedIn') !== null && localStorage.getItem('isLoggedIn').toString() === 'true') {
      navigate('/dashboard', { replace: true });
    }
  }, []);

  return (
    <CoverLayout
      title="Welcome back"
      description="Admin Login"
      image={curved9}
      top={0}
    >
      <SoftBox component="form" role="form">
        <SoftBox mb={2}>
          <SoftBox mb={1} ml={0.5}>
            <SoftTypography component="label" variant="caption" fontWeight="bold">
              Email
            </SoftTypography>
          </SoftBox>
          <SoftInput type="email" placeholder="Email" onChange={handleSetEmail} />
        </SoftBox>
        <SoftBox mb={2}>
          <SoftBox mb={1} ml={0.5}>
            <SoftTypography component="label" variant="caption" fontWeight="bold">
              Password
            </SoftTypography>
          </SoftBox>
          <SoftInput type="password" placeholder="Password" onChange={handleSetPassword} />
        </SoftBox>
        <SoftBox mt={4} mb={1}>
          <SoftButton variant="gradient" color="info" fullWidth onClick={!isLoading ? handleSignIn : () => { }}>
            {isLoading ? <Loader /> : 'sign in'}
          </SoftButton>
        </SoftBox>
      </SoftBox>
    </CoverLayout>
  );
}

export default SignIn;
